module.exports = __webpack_public_path__ + "img/DE00447.bebc6aab.png";